import { API } from '@/utils/api/api';

// TV-first pairing. Both calls are anonymous: the TV has no token until an admin adds it.

// Get a short-lived code (and a secret poll token) to show on screen.
export const createPairingRequestApi = async (formData) => {
  return await API.post('screen/pairing-requests', formData);
};

// "pending" until the code is claimed in the console, then "paired" with the screen's token.
export const pollPairingRequestApi = async (pollToken) => {
  return await API.post('screen/pairing-requests/poll', { pollToken });
};
